import React from 'react'

import { Fieldset, Input, Subsection } from '@fourthwall/components'

import { TinyMCE } from '../../../../../../../components/adapters/inputs/TinyMCE'
import { useSingleSeriesContext } from '../../hooks/useSingleSeriesContext'
import { FormFields } from '../../providers/SingleSeriesProvider/types'

export const DetailsFields = () => {
  const { form } = useSingleSeriesContext()

  return (
    <Subsection title="Video series details">
      <Fieldset>
        <Fieldset.Row>
          <Fieldset.Item>
            <Input {...form.getFieldProps(FormFields.title)} label="Series title" fullWidth />
          </Fieldset.Item>
        </Fieldset.Row>
        <Fieldset.Row>
          <Fieldset.Item>
            <TinyMCE
              {...form.getFieldProps(FormFields.description)}
              placeholder="Series description"
            />
          </Fieldset.Item>
        </Fieldset.Row>
      </Fieldset>
    </Subsection>
  )
}
